/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { useAuth } from "contexts/AuthContext";
import { Route } from "routes";
// chakra imports

export const SidebarLinks = (props: { routes: Route[] }): JSX.Element => {
  // Chakra color mode
  let location = useLocation();
  const { user } = useAuth();
  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName: string) => {
    return location.pathname.includes(routeName);
  };

  const createLinks = (routes: Route[]) => {
    return routes.map((route, index) => {
      // Skip routes that require specific roles if user doesn't have them
      if (route.roles && (!user?.roles || !route.roles.some(role => user.roles.includes(role)))) {
        return null;
      }

      // Skip hidden routes
      if (route.hidden) {
        return null;
      }

      if (
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/rtl"
      ) {
        return (
          <Link key={index} to={route.layout + "/" + route.path}>
            <div className="relative mb-3 flex hover:cursor-pointer">
              <li
                className="my-[3px] flex cursor-pointer items-center px-8"
                key={index}
              >
                <span
                  className={`${
                    activeRoute(route.path) === true
                      ? "font-bold text-brand-500 dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.icon ? route.icon : <DashIcon />}{" "}
                </span>
                <p
                  className={`leading-1 ml-4 flex ${
                    activeRoute(route.path) === true
                      ? "font-bold text-navy-700 dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.name}
                </p>
              </li>
              {activeRoute(route.path) ? (
                <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
              ) : null}
            </div>
          </Link>
        );
      }
      return null;
    }).filter(Boolean); // Remove null values from the array
  };
  // BRAND
  return <>{createLinks(routes)}</>;
};

export default SidebarLinks;
